/* eslint-disable react/require-default-props */
import { FindManyAcademicRankDocument } from '@/types/graphql/types'
import { useQuery } from '@apollo/client'
import { Loader, Select } from '@mantine/core'
import { GetInputPropsPayload } from '@mantine/form/lib/types'
import { toString } from 'lodash'
import useTranslation from 'next-translate/useTranslation'
import { ACADEMIC_RANK } from 'db'

const SelectUserAcademicRank = ({
  inputProps,
  required = false,
}: {
  inputProps: GetInputPropsPayload
  required?: boolean
}) => {
  const { t, lang } = useTranslation('common')
  const isArabic = lang === 'ar'

  const { data, loading } = useQuery(FindManyAcademicRankDocument)

  if (loading) return <Loader size="sm" />
  return (
    <Select
      required={required}
      label={t('academicRank')}
      {...inputProps}
      searchable
      nothingFound={t('noOptions')}
      data={
        data?.findManyAcademicRank?.filter(e=> e.id !== ACADEMIC_RANK.Other.id).map(p => ({
          value: toString(p.id || '-'),
          label: (isArabic ? p.titleAr ?? p.titleEn : p.titleEn) || '-',
        })) || []
      }
    />
  )
}

export default SelectUserAcademicRank
